const doctors = '专家'
const comment = '评论'
module.exports = {
    session_item: {
        time: '时间',
        topics: '讲题',
        doctors,
    },
    meeting_tab: {
        schedule: '日程',
        comment,
        doctors
    },
    meeting: {
        live_end: '直播已结束-点击观看回放视频',
        live_edited: '回放视频正在剪辑中,敬请期待',
        count_down: '距离直播',
        reserved: '已预约',
        appointment: '预约',
        pv_total: '直播间累计播放',
        pv_doctor: '医生播放量',
        pv_hospital: '医院播放量',
        other_session: '正在进行中',
        play_fail: '加载失败 点击重试'
    },
    comment: {
        comment,
        comment_placehold: '输入讨论内容',
        comment_dialog_placehold: '建议输入10字以上评论',
        cancel: '取消',
        send: '发送',
        sending: '发送中',
        reply: '回复',
        copy: '复制',
        delete: '删除',
        delete_confirm: '确认删除',
        delete_tips: '您确定要删除此评论?',
        delete_success: '删除成功',
        delete_fail: '删除失败',
        no_comment: '暂无在线互动',
        comment_list: '评论列表',
        no_more: '没有更多了'
    },
    appointment_dialog: {
        success: '恭喜您，预约成功-您将在会议开始前5分钟-收到短息消息提醒',
        confirm: '我知道了',
    }
}